import auth from './auth';
import http from './http';
import business from './business';
import lang from './lang';

export default {
    auth,
    http,
    business,
    lang
}



// WEBPACK FOOTER //
// ./src/config/index.js